module.exports = __webpack_public_path__ + "img/no-photo.aea67ce6.jpg";